<template>
    <div class="com-partm2">
        <MyTitle title="温度监控" />
        <div class="p-content flex align-center flex-wrap">
            <div
                v-for="(item, i) in list"
                :key="'list' + i"
                class="item flex justify-center flex-direction">
                <img v-if="!item.icon" class="item-c" :src="require('@/assets/images/computility/monitor-icon2.png')" alt="">
                <img v-else class="item-c" :src="require('@/assets/images/computility/monitor-icon3.png')" alt="">
                <dv-digital-flop style="height: 30px; width: 100%" :config="dvDigitalFlopConfig(item)" />
                <div class="item-l">{{ item.label }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import MyTitle from './myTitle1.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
        MyTitle
    },
    data() {
        return {
            list: []
        }
    },
	mounted() {
        // 获取数据
        this.getData()
    },
	methods: {
        // 字体动态
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.value || 0)
            let config = {
                number: [parseFloat(counts)],
                toFixed: 2,
                textAlign: item.textAlign || 'center',
                content: `{nt}${item.unit}`,
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 32,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            console.log('==config==', config)
            return config
        },
        // 获取数据
        async getData() {
            // let that = this
            let params = { 
                enCode: 'computingpower-left-wdjk',
            }
            let aaa = await dataInterface.dataFaceApi(params)
            let bbb = await dataInterface.getweather({'cityName': '苏州'})
            console.log('computingpower-left-fwqgl：温度监控', aaa)
            console.log('computingpower-left-fwqgl：温度监控', bbb)
            if(aaa && aaa.length) {
                this.list = aaa.map(item => {
                    return {
                        label: item.temperatureType,
                        value: item.temperatureValue,
                        color: '#03B9BD',
                        textAlign: 'left',
                        unit: '°C'
                    }
                })
            }
            if(bbb) {
                this.list.push({
                        label: '室外温度',
                        value: bbb.temp,
                        color: '#03B9BD',
                        textAlign: 'left',
                        unit: '°C'
                    })
                this.list.push({
                        label: '室外湿度',
                        value: bbb.humidity,
                        color: '#03B9BD',
                        icon: 1,
                        textAlign: 'left',
                        unit: '%'
                    })
            }
            // .then(res => {
            //     let data = res || []
            //     this.list = data.map(item => {
            //         return {
            //             label: item.temperatureType,
            //             value: item.temperatureValue,
            //             color: '#03B9BD',
            //             textAlign: 'left',
            //             unit: '°C'
            //         }
            //     })
            // })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.com-partm2 {
    width: 100%;
    .p-content {
        width: 100%;
        height: calc(100% - $TitleHeight);
        padding: 30px 0;
        .item {
            width: 50%;
            font-size: $FontSize20;
            padding: 10px 0 10px 100px;
            position: relative;
            .item-c {
                position: absolute;
                width: 80px;
                height: 80px;
                top: 50%;
                left: 0;
                transform: translate(0, -50%);
            }
        }
    }
}
</style>